module.exports = __webpack_public_path__ + "static/img/14000480.5dddae36.png";